import { useState, useEffect, useMemo } from 'react';
import ProductsContext from './ProductsContext';

// Provider component
export const ProductsProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        // Use the appropriate API URL based on environment
        const apiUrl = import.meta.env.DEV
          ? `${import.meta.env.VITE_BACKEND_URL_DEV}/api/products`
          : `${import.meta.env.VITE_BACKEND_URL_PROD}/api/products`;

        const response = await fetch(apiUrl);

        if (!response.ok) {
          throw new Error('Failed to fetch products');
        }

        const data = await response.json();
        setProducts(data.products);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching products');
        console.error(err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  // Memoize the context value to prevent unnecessary re-renders
  const value = useMemo(() => ({ products, loading, error }), [products, loading, error]);

  // Provide the products data and state to consuming components
  return (
    <ProductsContext.Provider value={value}>
      {children}
    </ProductsContext.Provider>
  );
};

